export const generateFieldId = (label?: string): string | undefined =>
  label?.toLowerCase().replace(/\s+/g, '-');
